import { Component, OnInit, Input, Output, EventEmitter, importProvidersFrom } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import * as _ from 'lodash';
import { CommonModule } from '@angular/common';
import { SearchSuggestModule, MMIconsModule } from 'mm-ui';
import { NgScrollbarModule } from 'ngx-scrollbar';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    SearchSuggestModule,
    MMIconsModule,
    NgScrollbarModule
  ],
  selector: 'mm-list-item-picker',
  templateUrl: './list-item-picker.component.html',
  styleUrls: ['./list-item-picker.component.scss']
})
export class ListItemPickerComponent implements OnInit {

  @Input('items') items: any[] = [];
  @Input('attribute') attribute: string;
  @Input('searchFn') searchFn: any;
  @Input('formControl') formControl = new UntypedFormControl(null);
  @Input('placeholder') placeholder: string;
  @Input('type') type: 'view' | 'edit';
  @Input('emitOnInit') emitOnInit = false;
  @Input('maxItems') maxItems: number;
  @Input('validateDuplicates') validateDuplicates = false;
  @Input('validateAttr') validateAttr = 'id'

  @Output('selected') selected = new EventEmitter();

  constructor() { }

  ngOnInit() {
    if (this.items.length && this.emitOnInit) {
      this.selected.emit({ items: this.items, type: 'onInit' })
    }
  }

  remove(index) {
    let removed = this.items[index];

    this.items.splice(index, 1);
    this.selected.emit({ items: this.items, type: 'removed', removed, index })
    this.formControl.reset();
  }

  addItem(item) {
    if (item == null) return;

    let added = item;
    if (this.maxItems) {
      if (this.items.length < this.maxItems) {
        this.items.push(item);
      }
    } else {
      this.items.push(item);
    }

    if (this.validateDuplicates) {
      this.items = _.uniqBy(this.items, (item) => item[this.validateAttr]);
    }

    this.selected.emit({ items: this.items, type: 'added', added });
    this.formControl.reset();
  }

}
